export default {
    TAB_COMMENTS: "Комментарии",
    LOAD_COMMENTS: "Запросить комментарии",
    TAB_LIKES: "Лайки",
    LOAD_LIKES: "Запросить лайки",
    TRUNCATE_SHOW: "Показать полностью",
    TRUNCATE_COLLAPSE: "Свернуть текст"
};
